import React, { FC } from 'react';
// import Button from '../Button';
import dateLib from '@/utils/dateLib/moment';

import './style.scss';
import { getTrans } from '@/utils/tools';

type CaseItem = any;

export interface EnquiryCaseCardProps {
  caseItem: CaseItem;
  hasOrderInfo: boolean;
  onCaseCardClick: ()=>void;
  onEnquiryClick?: ()=>void;
}

const EnquiryCaseCard: FC<EnquiryCaseCardProps> = ({ hasOrderInfo, caseItem, onCaseCardClick, onEnquiryClick }) => {
  const { case_id, first_enquiry_time, case_update_time, order_item_first_image_url, order_item_name, order_sn, enquiry_type_name } = caseItem;

  const firstEnquiryTime = dateLib.format(first_enquiry_time, 'MMM DD, HH:ii');
  const caseUpdateTime = dateLib.format(case_update_time, 'MMM DD, HH:ii');

  return (
    <div
      className="caseCardContainer"
      onClick={(e) => {
        // 如果有Enquiry 按钮
        if (onEnquiryClick) {
          const caseBtnContainer = document.querySelector(`#caseBtnContainer-${case_id}`);
          if (caseBtnContainer && !caseBtnContainer.contains(e.target as Node)) {
            onCaseCardClick();
          }
        } else {
          onCaseCardClick();
        }
      }}
    >
      <div className="caseCardTitle">
        <div className="caseCardTitle_Name_container">
          <div className="caseCardTitle_Name">
            {`${getTrans('case_enquiry_on')} ${enquiry_type_name || firstEnquiryTime}`}
          </div>
        </div>
        <div className="caseCardTitle_Time_container">
          <div className="caseCardTitle_Time">{caseUpdateTime}</div>
        </div>
      </div>

      {hasOrderInfo && (
        <div className="caseCardOrderInfo">
          <img className="caseCardOrderInfoImg" src={order_item_first_image_url} alt="Order" />
          <div className="caseCardOrderInfoDetail">
            <div>
              <div className="caseCardOrderInfoDetail_Name">
                {order_item_name}
              </div>
            </div>

            <div>
              <div className="caseCardOrderInfoDetail_SerialNumber">
                {`Order SN: ${order_sn}`}
              </div>
            </div>
          </div>
        </div>
      )}

      <div className={`caseCardFooter ${onEnquiryClick ? 'caseCardFooterPadding' : ''}`}>
        <div>
          <div className="caseCardFooter_CaseID">{`${getTrans('case_id')}: ${case_id}`}</div>
        </div>
        {
          onEnquiryClick && (
            <div
              id = {`caseBtnContainer-${case_id}`}
              className="caseBtnContainer"
              onClick={() => {
                // 关闭弹窗
                onEnquiryClick();

              }}
            >
              <div className="caseBtn">
                <div className="caseBtnText">
                  {getTrans('case_enquiry_this')}
                </div>
              </div>
            </div>
          )
        }
      </div>
    </div>
  );
};

export default EnquiryCaseCard;
